import { render, staticRenderFns } from "./MainWindow.vue?vue&type=template&id=4354df1c"
import script from "./MainWindow.vue?vue&type=script&lang=js"
export * from "./MainWindow.vue?vue&type=script&lang=js"
import style0 from "./MainWindow.vue?vue&type=style&index=0&id=4354df1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports